/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const personSkillDataSchema = z.object({
	escoSkillId: z.string(),
	conceptUri: z.string(),
	label: z.string(),
	sources: z.array(z.object({ candidateId: z.string(), questionId: z.string(), optionId: z.string() })),
})

export type PersonSkillDataSchema = z.infer<typeof personSkillDataSchema>
